import { createBlueprint as e } from "@made-people/blueprint";
const r = e({
  slots: {
    base: "flex flex-col px-3 mb-4 mt-2 gap-2 lg:h-full lg:p-6 lg:m-0 lg:min-w-[400px] lg:w-[25vw]",
    header: "flex justify-between items-center text-sm pb-4 mb-4 border-border-light border-b border-solid",
    close: "text-label-sm",
    cartItemsWrapper: "p-6 bg-white rounded-lg lg:h-full max-h-[70dvh] lg:max-h-none overflow-y-scroll",
    cartTotalsWrapper: "flex flex-col gap-5 lg:gap-6 p-6 bg-white rounded-lg",
    trustLogosBannerWrapper: "mb-4",
    emptyCartWrapper: "flex flex-col gap-4 items-center justify-center h-full",
    emptyCartMessage: "text-heading-lg",
    cartUpsellWrapper: "my-6"
  },
  variants: {}
});
export {
  r as miniCartLyonStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
